import { loadDataLayer } from '@delta-defense/frontend-analytics/loadDataLayer/loadDataLayer';
import React, { Component } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';

import { Cookies, CookieService } from '../../core/services/cookieService';
import { handleRouteChange } from '../../utilities/loadSegment';
import { CreateAccount } from '../CreateAccount/CreateAccount';
import { CreateNewPassword } from '../CreateNewPassword/CreateNewPassword';
import FourOFour from '../ErrorPage/404';
import { ForgotPassword } from '../ForgotPassword/ForgotPassword';
import Layout from '../Layout/Layout';
import { LogIn } from '../LogIn/LogIn';
import LogoutPage from '../LogoutPage/LogoutPage';
import RedirectChecker from '../RedirectChecker/RedirectChecker';

interface Props {
  cookieService: ReturnType<typeof CookieService.Instance>
}

class FormContainer extends Component<Props> {
  public static defaultProps = {
    cookieService: CookieService.Instance()
  };

  componentDidMount() {
    loadDataLayer();
    // @ts-expect-error FIXME: React Router prop types
    this.props.history.listen(handleRouteChange);

    //check if cookies exist
    (async () => {
      const path = window.location.pathname;
      const accessTokenSet = !!(await this.props.cookieService.getRaw(
        Cookies.USCCA_Access
      ));
      if (
        accessTokenSet &&
        !path.includes('logout') &&
        !path.includes('redirect')
      ) {
        // @ts-expect-error FIXME: React Router prop types
        this.props.history.push(`/redirect${window.location.search}`);
      }
    })();
  }

  handleKeyUp = (resetErrorHandler) => {
    // and if the following element exists remove the error message
    if (document.querySelector('[data-input-error]') != null) {
      resetErrorHandler();
    }
  };

  render() {
    return (
      <Layout>
        <Switch>
          <Route
            path="/"
            render={(props) => (
              <LogIn {...props} />
            )}
            exact={true}
          />

          <Route
            path="/forgot-password"
            render={() => <ForgotPassword />}
            exact={true}
          />

          <Route
            path="/forgot-password/:verificationId"
            render={(props) => (
              <CreateNewPassword
                cookieService={this.props.cookieService}
                {...props}
              />
            )}
          />

          <Route
            path="/register"
            render={() => <CreateAccount cookieService={this.props.cookieService} />}
            exact={true}
          />

          <Route path="/logout" component={LogoutPage} exact={true} />

          <Route
            path="/redirect"
            // @ts-expect-error TS(2559) FIXME: Type '{ history: History<unknown>; location: Locat... Remove this comment to see the full error message
            render={(props) => <RedirectChecker {...props} />}
            exact={false}
          />

          <Route path="*" component={FourOFour} />
        </Switch>
      </Layout>
    );
  }
}

// @ts-expect-error FIXME: React Router prop types
export default withRouter(FormContainer);
